// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"g1-z"};